var render = function render(){var _vm=this,_c=_vm._self._c;return _c(this.href ? 'a' : 'button',_vm._g({tag:"component",class:'btn btn-' + (_vm.variant || 'primary'),attrs:{"type":!this.href ? 'button' : '',"href":this.href}},_vm.$listeners),[(this.icon)?_c('i',{class:this.icon + (_vm.$slots.default ? ' mr-1' : '' )}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }